import { STORAGE_KEYS } from "../config";

export function getDeviceId(): string {
  const existing = localStorage.getItem(STORAGE_KEYS.deviceId);
  if (existing) return existing;
  const id = `web-${crypto.randomUUID()}`;
  localStorage.setItem(STORAGE_KEYS.deviceId, id);
  return id;
}

/** Mint a new portable id — call before binding a fresh enrollment. */
export function rotateDeviceId(): string {
  const id = `web-${crypto.randomUUID()}`;
  localStorage.setItem(STORAGE_KEYS.deviceId, id);
  return id;
}

/** Drop the local id after leave-device / abandon so it cannot be resumed. */
export function clearDeviceId(): void {
  localStorage.removeItem(STORAGE_KEYS.deviceId);
}

export function deviceLabel(): string {
  const ua = navigator.userAgent;
  if (/iPhone/i.test(ua)) return "Web · iPhone";
  if (/iPad/i.test(ua)) return "Web · iPad";
  if (/Android/i.test(ua)) return "Web · Android";
  if (/Mac/i.test(ua)) return "Web · Mac";
  if (/Windows/i.test(ua)) return "Web · Windows";
  return "Web";
}
